import { Injectable } from '@angular/core';

import { BehaviorSubject, Subject } from 'rxjs';

import { Markup } from '@ph-model/login';
import { ProductQuote } from '@ph-shopping/model/productQuote.model';
import { SortOptionIdEnum } from '@ph-shopping/model/sort-option';

@Injectable({
  providedIn: 'root',
})
export class ProductStoreRequestsDispatcher {
  private readonly _resetProductsTracker$ = new BehaviorSubject<number>(0);
  readonly resetProductsRequested$ = this._resetProductsTracker$.asObservable();

  private readonly _changeMarkupTracker$ = new Subject<Markup>();
  readonly changeMarkupRequested$ = this._changeMarkupTracker$.asObservable();

  private readonly _loadProductQuoteTracker$ = new Subject<ProductQuote>();
  readonly loadProductQuoteRequested$ = this._loadProductQuoteTracker$.asObservable();

  private readonly _sortByTracker$ = new Subject<SortOptionIdEnum>();
  readonly sortByTracker$ = this._sortByTracker$.asObservable();

  dispatchResetProducts(): void {
    this._resetProductsTracker$.next(this._resetProductsTracker$.value + 1);
  }

  dispatchChangeMarkup(markup: Markup): void {
    this._changeMarkupTracker$.next(markup);
  }

  dispatchLoadProductQuote(productQuote: ProductQuote): void {
    this._loadProductQuoteTracker$.next(productQuote);
  }

  dispatchSortByTracker(sortBy: SortOptionIdEnum): void {
    this._sortByTracker$.next(sortBy);
  }
}
